import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  Toolbar,
  IconButton,
  Stack,
  useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  purchaseArrtibuteApi,
  purchaseVanPostAndGenerateApi,
  purchaseVanVarianceApi
} from '../../Purchase/actions';
import { fAlertToast } from '../../../Utility/Utilitys';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { postVanReceivingTrans } from '../actions';
import { useDispatch } from 'react-redux';
import { updateTransHead } from '../VanReceivingSlice';

const toolbar = {
  backgroundColor: '#0d73bb',
  color: 'white',
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: '40px !important'
};

export const PostGenerateModal = ({ open, onClose, rdxTransHead, sItemList }) => {
  const vMediaQuery = useMediaQuery('(max-width:650px)');
  const navigate = useNavigate('');
  const dispatch = useDispatch('');
  const [sTruck, setTruck] = useState('');
  const [truckData, setTruckData] = useState([]);
  const [varianceData, setvarianceData] = useState([]);

  const fAttributes = async () => {
    const result = await purchaseArrtibuteApi({ OrderId: rdxTransHead?.Ord_ID });

    if (result.status === 200) {
      setTruckData(result?.data?.LocTruck);
      setTruck(rdxTransHead?.VanId || '');
    }
  };

  const fVarainceGetrow = async () => {
    const result = await purchaseVanVarianceApi({ VAN_TRNID: rdxTransHead?.transId });
    console.log(result);

    if (result.status === 200) {
      setvarianceData(result?.data?.data);
    }
  };

  const fCreate = async () => {
    const itemsVariance = sItemList?.filter((i) => Number(i.BalQty) !== 0);
    if (itemsVariance.length > 0 && rdxTransHead?.CNTRL_PUR === true) {
      fAlertToast('FAILED', 'Variance in quantity found!');
    } else {
      confirmAlert({
        title: 'Post',
        message:
          itemsVariance.length > 0
            ? 'Variance in quantity found!\nAre you sure to post?'
            : 'Are you sure to post?',
        buttons: [
          {
            label: 'Yes',
            className: 'alertBtn',
            onClick: async () => {
              const obj = {
                vanTransId: rdxTransHead?.transId
              };

              const result = await postVanReceivingTrans(obj);

              if (result?.data?.Type === 'Success') {
                fAlertToast('SUCCESS', 'Posted Successfully');

                dispatch(
                  updateTransHead({
                    ...rdxTransHead,
                    status: 'POST'
                  })
                );
                fGenerate();
              }
            }
          },
          {
            label: 'No',
            className: 'alertBtn',
            onClick: () => {}
          }
        ]
      });
    }
  };

  const fGenerate = async () => {
    try {
      const result = await purchaseVanPostAndGenerateApi({
        VAN_TRNID_OLD: rdxTransHead?.transId,
        TL_VAN_ID: sTruck
      });

      if (result.status === 200) {
        fAlertToast('SUCCESS', 'Generated successfully');
        navigate('/VanTransSummary');
      }
    } catch {
      console.log('Post cancelled or failed');
    }
  };

  const fClose = () => {
    onClose();
    setTruck('');
  };

  useEffect(() => {
    if (open) {
      fAttributes();
      fVarainceGetrow();
      setTruck(rdxTransHead?.VanId);
    }
  }, [open]);

  const columns = [
    {
      field: 'VAN_ITMCD',
      headerName: 'ItmCd',
      align: 'left',
      headerAlign: 'left',
      hide: true,
      width: 110
    },
    {
      field: 'ItemName',
      headerName: 'Item Name',
      flex: 1,
      minWidth: 120,
      align: 'left',
      headerAlign: 'left'
    },
    {
      field: 'VAN_UNIT',
      headerName: 'Unit',
      width: 100,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: 'VANQty',
      headerName: 'VANQty',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ({ value }) => Number(value).toFixed(0)
    },
    {
      field: 'ReceivedQty',
      headerName: 'ReceivedQty',
      hide: false,
      align: 'center',
      headerAlign: 'center',
      width: 100
    },
    {
      field: 'Diff',
      headerName: 'Diff',
      hide: false,
      align: 'center',
      headerAlign: 'center',
      width: 100
    }
  ];

  return (
    <Dialog open={open} fullWidth maxWidth={vMediaQuery ? 'lg' : 'sm'}>
      <Toolbar sx={toolbar}>
        <DialogTitle sx={{ backgroundColor: '#0d73bb', color: 'white', padding: '0px !important' }}>
          Transfer New Truck
        </DialogTitle>
        <IconButton edge="end" color="inherit" onClick={fClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Toolbar>

      <DialogContent dividers sx={{ paddingX: vMediaQuery ? 1 : 4, paddingY: vMediaQuery ? 1 : 3 }}>
        <Stack
          mb={1}
          direction={vMediaQuery ? 'column' : 'row'}
          spacing={2}
          sx={{ justifyContent: 'space-between' }}>
          <Typography variant="body2" color={'primary'}>
            Van ID :{' '}
            <strong style={{ color: '#211111', fontWeight: 400 }}>{rdxTransHead?.transId}</strong>
          </Typography>
          <Typography variant="body2" color={'primary'}>
            Buyer :{' '}
            <strong style={{ color: '#211111', fontWeight: 400 }}>{rdxTransHead?.Buyer}</strong>
          </Typography>
          <Typography variant="body2" color={'primary'}>
            Truck :{' '}
            <strong style={{ color: '#211111', fontWeight: 400 }}>{rdxTransHead?.Truck}</strong>
          </Typography>
        </Stack>

        <Box py={2}>
          <FormControl fullWidth size="small">
            <InputLabel id="truck-label">Truck</InputLabel>
            <Select
              labelId="truck-label"
              id="truck-select"
              label="Truck"
              name="Truck"
              value={sTruck}
              onChange={(event) => setTruck(event.target.value)}>
              {truckData?.map((truck) => (
                <MenuItem key={truck.UId} value={truck.UId}>
                  {truck.Name1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box textAlign={vMediaQuery ? 'center' : 'right'} >
          <Button
            variant="contained"
            sx={{ textTransform: 'capitalize', width: vMediaQuery ? '40%' : '20%' }}
            onClick={fCreate}>
            Create
          </Button>
        </Box>

        <Box
          sx={{
            height: vMediaQuery?'50vh':'60vh',
            width: '100%',
            mt: '15px'
          }}>
          <DataGrid
            sx={{
              '& .editable-cell': {
                backgroundColor: '#edfaff',
                border: '1px solid lightgray',
                borderRadius: '6px'
              },
              borderColor: 'primary.light',
              border: 1,
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#0d73bb',
                color: 'white'
              }
            }}
            rowHeight={30}
            headerHeight={35}
            rows={varianceData}
            columns={columns}
            getRowId={(row) => row.VAN_ITMCD}
            disableRowSelectionOnClick
            hideFooter
            disableSelectionOnClick
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};
